import React, { Component } from 'react';
import { TweenMax } from 'gsap';
import progressListener from './lib/progressListener';

import style from './PlaylistVideo.module.scss';

const getBodyTextQuadrant = body_quadrant => {
  switch (body_quadrant) {
    case 'bottomright':
      return `${style.videoTextBottomRight}`;
    case 'topright':
      return `${style.videoTextTopRight}`;
    case 'topleft':
      return `${style.videoTextTopLeft}`;
    default:
      return `${style.videoTextBottomLeft}`;
  }
};

class PlaylistVideo extends Component {
  videos = [];
  videoText = [];
  state = {
    showBk: false,
    prevActive: null,
    screenOrientation: '',
  };
  setScreenOrientation = (callback = () => {}) => {
    if (typeof window !== 'undefined') {
      if (window.innerHeight < window.innerWidth) {
        this.setState(
          {
            screenOrientation: 'landscape',
          },
          callback
        );
      } else {
        this.setState(
          {
            screenOrientation: 'portrait',
          },
          callback
        );
      }
    }
  };
  videoTimeUpdate = () => {
    if (this.props.isPlaylistOpen && this.videos[0] !== null) {
      progressListener.progress(
        this.videos[this.props.activeVideo].currentTime,
        this.videos[this.props.activeVideo].duration
      );

      requestAnimationFrame(this.videoTimeUpdate);
    }
  };

  componentDidMount() {
    this.setScreenOrientation();
    // this probably never fires b/c can't mount without press
    // Start animations and play video
    if (this.props.isPlaylistOpen) {
      this.videos[this.props.activeVideo].play();
      this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
    }
  }

  playWhenReady = video => {
    const checkReadyState = () => {
      // playlist remembers the previous active video and holds it on screen
      // until the next one can play, then they cross fade.
      if (video.readyState === 4) {
        this.setState({ prevActive: null });

        video.play();
      } else {
        requestAnimationFrame(checkReadyState);
      }
    };
    requestAnimationFrame(checkReadyState);
  };

  componentWillReceiveProps(nextProps) {
    // When video is opened:
    if (
      this.props.isPlaylistOpen !== nextProps.isPlaylistOpen &&
      nextProps.isPlaylistOpen
    ) {
      // Reset videos back to 0
      for (let video in this.videos) {
        this.videos[video].currentTime = 0;
      }

      // Play active video and start progress bar
      if (this.videos[this.props.activeVideo]) {
        this.props.togglePlayPause();
        // this.playWhenReady(this.videos[this.props.activeVideo]);
        this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
      }
    }

    // When video changes
    // Check if video switches, then play videos and start progress bar
    if (
      this.props.isPlaylistOpen &&
      this.props.activeVideo !== nextProps.activeVideo &&
      this.videos[nextProps.activeVideo] !== undefined
    ) {
      this.videos[this.props.activeVideo].pause();
      this.videos[nextProps.activeVideo].currentTime = 0;
      this.setState({ prevActive: this.props.activeVideo });
      this.playWhenReady(this.videos[nextProps.activeVideo]);
      this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
    }

    // When video is closed
    // Check if Playlist is closed
    if (
      this.props.isPlaylistOpen !== nextProps.isPlaylistOpen &&
      !nextProps.isPlaylistOpen
    ) {
      this.setState({
        showBk: false,
        prevActive: null,
      });
      this.videos[this.props.activeVideo].pause();
    }

    // Check whether video is playing or paused
    if (
      this.props.isVideoPause !== nextProps.isVideoPaused &&
      this.videos[nextProps.activeVideo] !== undefined
    ) {
      if (nextProps.isVideoPaused) {
        this.videos[nextProps.activeVideo].pause();
      } else {
        this.videos[nextProps.activeVideo].play();
      }
    }
  }

  componentDidUpdate(prevProps) {
    // if src changes, need to call load method ¯\_(ツ)_/¯
    if (prevProps.playlistVideoData !== this.props.playlistVideoData) {
      this.videos.length = this.props.playlistVideoData.length;
      this.videoText.length = this.props.playlistVideoData.length;
    }
    if (prevProps.screenOrientation !== this.props.screenOrientation) {
      this.setScreenOrientation(() => {
        this.videos[this.props.activeVideo].load();
      });
    }
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
  }

  onVideoComplete = () => {
    this.props.videoEnded();
  };
  onVideoPlay = () => {
    if (!this.state.showBk) {
      setTimeout(() => {
        this.setState({ showBk: true });
      }, 1500);
    }
  };

  render() {
    const {
      screenOrientation,
      isPlaylistOpen,
      playlistVideoData,
      videoEnded,
    } = this.props;

    return (
      <div
        className={`playlist-video ${style.videoWrapper} ${
          isPlaylistOpen ? style.playlistOpen : ''
        } ${this.state.showBk ? style.hasBackground : ''}`}
        style={{ pointerEvents: isPlaylistOpen ? 'auto' : 'none' }}
      >
        {playlistVideoData.map((video, i) => {
          return (
            <div
              key={`${video.body}-${i}`}
              className={`${style.videoWrap} ${
                (i === this.props.activeVideo || i === this.state.prevActive) &&
                this.props.isPlaylistOpen
                  ? style.isActive
                  : ''
              } playlist-video--${i}`}
            >
              <div
                className={`${
                  i === this.props.activeVideo && this.props.isPlaylistOpen
                    ? style.activeVideoText
                    : ''
                } ${style.videoText} ${getBodyTextQuadrant(
                  video.body_quadrant
                )}`}
                dangerouslySetInnerHTML={{ __html: video.body }}
              />

              <video
                ref={el => (this.videos[i] = el)}
                src={
                  this.state.screenOrientation === 'landscape'
                    ? video.source.landscape.url
                    : video.source.portrait.url
                }
                className={`${
                  (i === this.props.activeVideo ||
                    i === this.state.prevActive) &&
                  this.props.isPlaylistOpen
                    ? style.activeVideo
                    : ''
                } ${style.video}`}
                playsInline
                onEnded={this.onVideoComplete}
                onPlay={this.onVideoPlay}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default PlaylistVideo;



// WEBPACK FOOTER //
// ./src/components/global/playlist/PlaylistVideo.js